@if (searchData && searchData.length > 0) {
  <div class="w-72">
    <app-search-input 
      [options]="searchData" 
      [placeholder]="'Enter section number...'"
      [cssClasses]="['input-search']"
      (filterValues)="filterSections($event)"
      (hoveredValue)="highlightSection($event)"
      (updatedValue)="selectAndNavigateToSection($event)"
      >
    </app-search-input>
  </div>
}